import {
	Box,
	Card,
	CardContent,
	Container,
	Divider,
	IconButton,
	Tooltip,
	Typography,
} from "@mui/material";
import { useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import Spinner from "src/components/Spinner/Spinner";
import SuspenseLoader from "src/components/SuspenseLoader";
import { useApiQuery } from "src/hooks/useApiQuery";
import type { IAccountDetails } from "src/Types/account.types";
import SingleAccountDetails from "./SingleAccountDetails";
import UpdateAccount from "./UpdateAccount";

const SingleAccountPage = () => {
	const [showModal, setShowModal] = useState<boolean>(false);

	const id = Number(useParams().id);

	const { data: account, isLoading } = useApiQuery<IAccountDetails>({
		endPoint: `/api/fair/admin/account/${id}`,
		queryKeys: ["Account", id],
	});

	if (isLoading) {
		return <Spinner />;
	}

	return (
		<section>
			<Helmet>
				<title>BTTF - Account Details: {account.ac_name}</title>
			</Helmet>
			<Container sx={{ mt: 4 }} maxWidth="xl">
				<Card>
					<CardContent>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: "5px",
							}}
						>
							<Typography variant="h4" color="text.primary">
								Account Details: {account.ac_name}
							</Typography>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									gap: "5px",
								}}
							>
								<Tooltip title="Edit">
									<IconButton
										onClick={() => setShowModal(!showModal)}
										sx={{ cursor: "pointer" }}
									>
										<EditIcon />
									</IconButton>
								</Tooltip>
							</Box>
						</Box>
						<Divider />
						{isLoading ? (
							<SuspenseLoader />
						) : (
							<SingleAccountDetails account={account} />
						)}

						{/* UPDATE */}
						<ModalsWrapper
							showModal={showModal}
							setShowModal={setShowModal}
							modalData={{
								title: `Update Account: ${account.ac_name}`,
							}}
						>
							<UpdateAccount
								id={id}
								handleClose={() => setShowModal(false)}
							/>
						</ModalsWrapper>
					</CardContent>
				</Card>
			</Container>
		</section>
	);
};

export default SingleAccountPage;
